<template>
  <v-container fluid>
    <v-layout class="ml-n2 mt-10">
      <v-flex>
        <v-row justify="end" v-if="deliveryMeals">
          <PrintOrderItems :reportList="deliveryMeals" :headers="headers" :disabled="false" />
          <MealStickerPrint :reportList="deliveryMeals" class="text-end" />
        </v-row>
      </v-flex>
    </v-layout>
    <v-container fluid class="mt-5 ml-n3">
      <v-data-table
        :mobile-breakpoint="0"
        id="myTable"
        :headers="headers"
        :items="itemsWithSno"
        :loading="loading"
        item-key="slNo"
        class="elevation-1 mt-6"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
      >
        <template v-slot:item.meal="{ item }">
          {{ item.menu.nameEn }}
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import { DATE_FORMAT, TIME_ZONE } from "../../utils/utils";

import MealStickerPrint from "../components/MealStickerPrint.vue";
import PrintOrderItems from "../components/PrintOrderItems.vue";
export default {
  components: { PrintOrderItems, MealStickerPrint },

  watch: {
    "$route.query.masterId": {
      handler() {
        console.log("this.$route.query.masterId", this.$route.query.masterId);
        this.getDeliveryDetailsByDate();
      },
    },
  },

  methods: {
    searchDelivery() {
      this.getSetMenuCustomerDeliveryList();
    },
    getDeliveryStatus(deliveryStatus) {
      if (deliveryStatus == "PENDING") {
        deliveryStatus = "Pending";
      }
      if (deliveryStatus == "DELIVERED") {
        deliveryStatus = "Delivered";
      }
      if (deliveryStatus == "NOT_DELIVERED") {
        deliveryStatus = "Not Delivered";
      }
      return deliveryStatus;
    },
    getDate(date) {
      let converted = moment(date).tz(TIME_ZONE);
      return converted;
    },
    padLeft(number, length) {
      var stringValue = "" + number;
      while (stringValue.length < length) {
        stringValue = "0" + stringValue;
      }
      return stringValue;
    },
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getSetmenuMealList() {
      debugger;
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getSetmenuMealList.graphql"),
          variables: {
            reportId: this.$route.query.reportId,
            shift: "All",
            deliveryStatus: "All",
          },
        })
        .refetch({
          variables: {
            reportId: this.$route.query.reportId,
            shift: "All",
            deliveryStatus: "All",
          },
        })
        .then(data => {
          this.loading = false;
          this.hasData = true;
          if (data.data.getSetmenuMealList) {
            this.deliveryMeals = data.data.getSetmenuMealList.meals;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    driverId: "",
    btnloading: false,
    deliveryStatus: "All",
    deliveryShift: "MORNING",
    orderDeliveryDetails: [],
    fieldToSearch: "",
    hasData: false,
    deliveryMeals: null,
    driverList: [],
    skip: 0,
    limit: 25,
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    headers: [
      { text: "Sl No.", value: "slNo", width: 50, sortable: false },
      {
        text: "Meal",
        value: "meal",
        width: 150,
        sortable: false,
      },
      {
        text: "Count",
        value: "count",
        width: 80,
        sortable: false,
      },
    ],
  }),
  computed: {
    itemsWithSno() {
      if (this.deliveryMeals == null) return [];
      return this.deliveryMeals.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
    formatDate() {
      return this.date ? moment(this.date).format(DATE_FORMAT) : "";
    },
  },
  created() {},
  mounted() {
    this.getSetmenuMealList();
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
